/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuepAliases {
  ACTION_OPTION_MODEL = 'action-option-model',
  ACTION_VIEW_ALL = 'action-view-all',
  ACTION_VIEW_ALL_CPOE = 'action-view-all-cpoe',
  ACTION_VIEW_ALL_DEVICES = 'action-view-all-devices',
  ACTION_VIEW_ALL_DIAGNOSIS = 'action-view-all-diagnosis',
  ACTION_VIEW_ALL_HYDRIC_BALANCE = 'action-view-all-hydric-balance',
  ACTION_VIEW_ALL_INTAKES_OUTPUTS = 'action-view-all-intakes-outputs',
  ACTION_VIEW_ALL_LAB_EXAMS = 'action-view-all-lab-exams',
  ACTION_VIEW_ALL_NON_LAB_EXAMS = 'action-view-all-non-lab-exams',
  ACTION_VIEW_ALL_SCORE_INDEXES = 'action-view-all-score-indexes',
  ACTION_VIEW_ALL_VITAL_SIGN = 'action-view-all-vital-sign',
  CARD_CONTAINER_BODY_CPOE = 'card-container-body-cpoe',
  CARD_CONTAINER_CPOE = 'card-container-cpoe',
  CARD_CONTAINER_ZONE_DIALYSIS = 'card-container-zone-dialysis',
  CARD_CONTAINER_ZONE_DIALYSIS_ICON = 'card-container-zone-dialysis-icon',
  CARD_CONTAINER_ZONE_DIALYSIS_QUANTITY = 'card-container-zone-dialysis-quantity',
  CARD_CONTAINER_ZONE_EXAMS_PROCEDURES = 'card-container-zone-exams-procedures',
  CARD_CONTAINER_ZONE_EXAMS_PROCEDURES_ICON = 'card-container-zone-exams-procedures-icon',
  CARD_CONTAINER_ZONE_EXAMS_PROCEDURES_QUANTITY = 'card-container-zone-exams-procedures-quantity',
  CARD_CONTAINER_ZONE_GASTHERAPY = 'card-container-zone-gastherapy',
  CARD_CONTAINER_ZONE_GASTHERAPY_ICON = 'card-container-zone-gastherapy-icon',
  CARD_CONTAINER_ZONE_GASTHERAPY_QUANTITY = 'card-container-zone-gastherapy-quantity',
  CARD_CONTAINER_ZONE_HEMOTHERAPY = 'card-container-zone-hemotherapy',
  CARD_CONTAINER_ZONE_HEMOTHERAPY_ICON = 'card-container-zone-hemotherapy-icon',
  CARD_CONTAINER_ZONE_HEMOTHERAPY_QUANTITY = 'card-container-zone-hemotherapy-quantity',
  CARD_CONTAINER_ZONE_INFUSIONS_MEDICINES = 'card-container-zone-infusions-medicines',
  CARD_CONTAINER_ZONE_INFUSIONS_MEDICINES_ICON = 'card-container-zone-infusions-medicines-icon',
  CARD_CONTAINER_ZONE_INFUSIONS_MEDICINES_QUANTITY = 'card-container-zone-infusions-medicines-quantity',
  CARD_CONTAINER_ZONE_NURSING_INTERVENTIONS = 'card-container-zone-nursing-interventions',
  CARD_CONTAINER_ZONE_NURSING_INTERVENTIONS_ICON = 'card-container-zone-nursing-interventions-icon',
  CARD_CONTAINER_ZONE_NURSING_INTERVENTIONS_QUANTITY = 'card-container-zone-nursing-interventions-quantity',
  CARD_CONTAINER_ZONE_NUTRITION = 'card-container-zone-nutrition',
  CARD_CONTAINER_ZONE_NUTRITION_ICON = 'card-container-zone-nutrition-icon',
  CARD_CONTAINER_ZONE_NUTRITION_QUANTITY = 'card-container-zone-nutrition-quantity',
  CARD_CONTAINER_ZONE_RECOMMENDATIONS = 'card-container-zone-recommendations',
  CARD_CONTAINER_ZONE_RECOMMENDATIONS_ICON = 'card-container-zone-recommendations-icon',
  CARD_CONTAINER_ZONE_RECOMMENDATIONS_QUANTITY = 'card-container-zone-recommendations-quantity',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_CPOE = 'contextual-bar-cpoe',
  CONTEXTUAL_BAR_DEVICES = 'contextual-bar-devices',
  CONTEXTUAL_BAR_DIAGNOSIS = 'contextual-bar-diagnosis',
  CONTEXTUAL_BAR_HYDRIC_BALANCE = 'contextual-bar-hydric-balance',
  CONTEXTUAL_BAR_INTAKES_OUTPUTS = 'contextual-bar-intakes-outputs',
  CONTEXTUAL_BAR_LAB_EXAMS = 'contextual-bar-lab-exams',
  CONTEXTUAL_BAR_NON_LAB_EXAMS = 'contextual-bar-non-lab-exams',
  CONTEXTUAL_BAR_SCORE_INDEXES = 'contextual-bar-score-indexes',
  CONTEXTUAL_BAR_SUEP = 'contextual-bar-suep',
  CONTEXTUAL_BAR_VITAL_SIGN = 'contextual-bar-vital-sign',
  DEVICES_CARD = 'devices-card',
  FETCH_CPOE = 'fetch-cpoe',
  FETCH_SCORE_INDEXES = 'fetch-score-indexes',
  ICON_SWITCHER_DIALYSIS = 'icon-switcher-dialysis',
  ICON_SWITCHER_EXAMS_PROCEDURES = 'icon-switcher-exams-procedures',
  ICON_SWITCHER_GASTHERAPY = 'icon-switcher-gastherapy',
  ICON_SWITCHER_HEMOTHERAPY = 'icon-switcher-hemotherapy',
  ICON_SWITCHER_INFUSIONS_MEDICINES = 'icon-switcher-infusions-medicines',
  ICON_SWITCHER_NURSING_INTERVENTIONS = 'icon-switcher-nursing-interventions',
  ICON_SWITCHER_NUTRITION = 'icon-switcher-nutrition',
  ICON_SWITCHER_RECOMMENDATIONS = 'icon-switcher-recommendations',
  IDENTIFIABLE_DIALYSIS = 'identifiable-dialysis',
  IDENTIFIABLE_EXAMS_PROCEDURES = 'identifiable-exams-procedures',
  IDENTIFIABLE_GASTHERAPY = 'identifiable-gastherapy',
  IDENTIFIABLE_HEMOTHERAPY = 'identifiable-hemotherapy',
  IDENTIFIABLE_INFUSIONS_MEDICINES = 'identifiable-infusions-medicines',
  IDENTIFIABLE_NURSING_INTERVENTIONS = 'identifiable-nursing-interventions',
  IDENTIFIABLE_NUTRITION = 'identifiable-nutrition',
  IDENTIFIABLE_RECOMMENDATIONS = 'identifiable-recommendations',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_ORDER = 'layout-order',
  LAYOUT_PDF_PANEL_LOADER = 'layout-pdf-panel-loader',
  LAYOUT_SUEP = 'layout-suep',
  LEGENDS_0 = 'legends-0',
  LEGENDS_DEVICES = 'legends-devices',
  LEGENDS_INTAKES_OUTPUTS = 'legends-intakes-outputs',
  LEGENDS_SCORE_INDEXES = 'legends-score-indexes',
  LEGENDS_VITAL_SIGN = 'legends-vital-sign',
  LOADER_0 = 'loader-0',
  MAPPER_SCORE_INDEXES = 'mapper-score-indexes',
  MEDIA_CONTAINER_NON_LAB = 'media-container-non-lab',
  MODAL_SUEP = 'modal-suep',
  PANEL_CLINICAL_NOTES = 'panel-clinical-notes',
  PANEL_CPOE = 'panel-cpoe',
  PANEL_DEVICES = 'panel-devices',
  PANEL_DIAGNOSIS = 'panel-diagnosis',
  PANEL_DIALYSIS_ICON = 'panel-dialysis-icon',
  PANEL_DIALYSIS_QUANTITY = 'panel-dialysis-quantity',
  PANEL_EXAMS_PROCEDURES_ICON = 'panel-exams-procedures-icon',
  PANEL_EXAMS_PROCEDURES_QUANTITY = 'panel-exams-procedures-quantity',
  PANEL_GASTHERAPY_ICON = 'panel-gastherapy-icon',
  PANEL_GASTHERAPY_QUANTITY = 'panel-gastherapy-quantity',
  PANEL_HEMOTHERAPY_ICON = 'panel-hemotherapy-icon',
  PANEL_HEMOTHERAPY_QUANTITY = 'panel-hemotherapy-quantity',
  PANEL_HYDRIC_BALANCE = 'panel-hydric-balance',
  PANEL_INFUSIONS_MEDICINES_ICON = 'panel-infusions-medicines-icon',
  PANEL_INFUSIONS_MEDICINES_QUANTITY = 'panel-infusions-medicines-quantity',
  PANEL_INTAKES_OUTPUTS = 'panel-intakes-outputs',
  PANEL_LAB_EXAMS = 'panel-lab-exams',
  PANEL_NON_LAB_EXAMS = 'panel-non-lab-exams',
  PANEL_NURSING_INTERVENTIONS_ICON = 'panel-nursing-interventions-icon',
  PANEL_NURSING_INTERVENTIONS_QUANTITY = 'panel-nursing-interventions-quantity',
  PANEL_NUTRITION_ICON = 'panel-nutrition-icon',
  PANEL_NUTRITION_QUANTITY = 'panel-nutrition-quantity',
  PANEL_RECOMMENDATIONS_ICON = 'panel-recommendations-icon',
  PANEL_RECOMMENDATIONS_QUANTITY = 'panel-recommendations-quantity',
  PANEL_SCORES_INDEXES = 'panel-scores-indexes',
  PANEL_TABLE = 'panel-table',
  PANEL_TABLE_CPOE = 'panel-table-cpoe',
  PANEL_TABLE_DEVICES = 'panel-table-devices',
  PANEL_TABLE_DIAGNOSIS = 'panel-table-diagnosis',
  PANEL_TABLE_HYDRIC_BALANCE = 'panel-table-hydric-balance',
  PANEL_TABLE_INTAKES_OUTPUTS = 'panel-table-intakes-outputs',
  PANEL_TABLE_LAB_EXAMS = 'panel-table-lab-exams',
  PANEL_TABLE_NON_LAB_EXAMS = 'panel-table-non-lab-exams',
  PANEL_TABLE_SCORE_INDEXES = 'panel-table-score-indexes',
  PANEL_TABLE_VITAL_SIGN = 'panel-table-vital-sign',
  PANEL_VITAL_SIGN = 'panel-vital-sign',
  SCORES_INDEXES_SUEP_CARD_CONTAINER_0 = 'scores-indexes-suep-card-container-0',
  SORTABLE_CPOE = 'sortable-cpoe',
  SUEP_CARD = 'suep-card',
  SUEP_CARD_DIAGNOSIS = 'suep-card-diagnosis',
  SUEP_CARD_HYDRIC_BALANCE = 'suep-card-hydric-balance',
  SUEP_CARD_INTAKES_OUTPUTS = 'suep-card-intakes-outputs',
  SUEP_CARD_LAB_EXAMS = 'suep-card-lab-exams',
  SUEP_CARD_LIST_DECK = 'suep-card-list-deck',
  SUEP_CARD_LIST_DECK_CPOE = 'suep-card-list-deck-cpoe',
  SUEP_CARD_LIST_DECK_DEVICES = 'suep-card-list-deck-devices',
  SUEP_CARD_LIST_DECK_DIAGNOSIS = 'suep-card-list-deck-diagnosis',
  SUEP_CARD_LIST_DECK_HYDRIC_BALANCE = 'suep-card-list-deck-hydric-balance',
  SUEP_CARD_LIST_DECK_INTAKES_OUTPUTS = 'suep-card-list-deck-intakes-outputs',
  SUEP_CARD_LIST_DECK_LAB_EXAMS = 'suep-card-list-deck-lab-exams',
  SUEP_CARD_LIST_DECK_NON_LAB_EXAMS = 'suep-card-list-deck-non-lab-exams',
  SUEP_CARD_LIST_DECK_SCORE_INDEXES = 'suep-card-list-deck-score-indexes',
  SUEP_CARD_LIST_DECK_VITAL_SIGN = 'suep-card-list-deck-vital-sign',
  SUEP_CARD_NON_LAB_EXAMS = 'suep-card-non-lab-exams',
  SUEP_CARD_VITAL_SIGN = 'suep-card-vital-sign',
  SUEP_FIELD_DESCRIPTION = 'suep-field-description',
  SUEP_PANEL_MODAL = 'suep-panel-modal',
  SUEP_PANEL_NON_LAB = 'suep-panel-non-lab',
  SUEP_TEXT_DESCRIPTION = 'suep-text-description',
  TEXT_DIALYSIS = 'text-dialysis',
  TEXT_EXAMS_PROCEDURES = 'text-exams-procedures',
  TEXT_GASTHERAPY = 'text-gastherapy',
  TEXT_HEMOTHERAPY = 'text-hemotherapy',
  TEXT_INFUSIONS_MEDICINES = 'text-infusions-medicines',
  TEXT_NURSING_INTERVENTIONS = 'text-nursing-interventions',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_RECOMMENDATIONS = 'text-recommendations',
}
export { SuepAliases };
